import { format } from 'date-fns';
import type { ProviderFormatSettings } from './types';

export const getNumberFormatPreview = ({
  numeric_formats,
}: ProviderFormatSettings) => {
  const decimalArray = new Array(numeric_formats.decimal_places).fill(1);
  const decimalPart = decimalArray.map((_) => '2').join('');
  const thousandsSeparator = numeric_formats.thousands_separator;
  const decimalSeparator = decimalPart ? numeric_formats.decimal_separator : '';
  const number = `22${thousandsSeparator}222${decimalSeparator}${decimalPart}`;
  return numeric_formats.negative_sign === 'minus'
    ? `-${number}`
    : `(${number})`;
};

export const getCurrencyPreview = ({
  numeric_formats,
}: ProviderFormatSettings) => {
  return numeric_formats.currency_position === 'before'
    ? `${numeric_formats.currency}100`
    : `100${numeric_formats.currency}`;
};

export const getDatePreview = ({ date_formats }: ProviderFormatSettings) => {
  const { date, separator } = date_formats;
  const dateFormat = date.replace(/\//g, separator);
  return format(new Date(), dateFormat);
};

export const getYearMonthPreview = ({
  date_formats,
}: ProviderFormatSettings) => {
  const { yearmonth, separator } = date_formats;
  const dateFormat = yearmonth.replace(/\//g, separator);
  return format(new Date(), dateFormat);
};

export const getDateTimePreview = ({
  date_formats,
}: ProviderFormatSettings) => {
  const { datetime } = date_formats;
  try {
    const date = new Date();
    date.setHours(22, 22, 22, 22);
    return format(date, datetime);
  } catch (e) {
    return 'Invalid format';
  }
};
